import { Component, ViewChild } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { Subject } from 'rxjs/Subject';
import { UtilityProvider } from "../../providers/utility/utility";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import moment from "moment";

@IonicPage()
@Component({
  selector: "page-report-patient-details",
  templateUrl: "report-patient-details.html"
})
export class ReportPatientDetailsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  displayedColumns = [
    'program_patient_id', 
    'province', 'therapy', 
    'indication', 
    'diagnosis_date', 
    'gender', 
    'weight', 
    'dob', 
    'status', 
    'substatus', 
    'status_date', 
    'enrolment_received', 
    //'Enrolment_Call_1', 'Enrolment_Call_2', 'Enrolment_Call_3', 'Pending_Reimbursement', 'On_Drug', 'welcome_package_ordered', 'welcome_package_sent', 'welcome_letter_sent', 
    'dose', 'doctor.first_name', 'doctor.last_name', 'doctor.program_physician_id'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public patientList: Observable<any[]>;
  program_name: string;
  program_id: string;
  start_date = moment('2019-09-01').toDate();
  end_date = moment().toDate();
  query_field = 'createdAt';
  patients: any[] = [];
  apatients: any[] = [];
  exportjson: any[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public utility: UtilityProvider
  ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      this.getPatients();
    });
  }

  ngOnDestroy() {
    console.log('Leave patient report view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getPatients() {
    this.database
    .getPatientsByProgramDateRange(this.program_id, this.query_field, this.start_date, this.end_date)
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe((patients) => {
      let pats = [];
      this.apatients = [];
      patients.forEach(item => {
        item['drugtype'] = this.utility.getDrugType(item.reimbursement_private, item.reimbursement_private_other, item.reimbursement_public, item.reimbursement_compassionate);
        item['reimbursementtype'] = this.utility.getReimbursementType(item.reimbursement_private, item.reimbursement_private_other, item.reimbursement_public, item.reimbursement_compassionate, item.reimbursement_fa);
        item['reimbursementstatus'] = this.utility.getReimbursementActiveType(item.reimbursement_private, item.reimbursement_private_other, item.reimbursement_public);
        pats.push(item);
      })
      this.exportjson = pats;
      this.exportjson.forEach((p) => {
        let patientex = {
          'Patient ID': null,
          'E Month': null,
          'E Qtr': null,
          'E Year': null,
          'E Week': null,
          'First Name': null,
          'Last Name': null,
          'Province': null,
          'Therapy': null,
          'Indication': null,
          'Diagnosis Date': null,
          'Gender': null,
          'Weight': null,
          'DOB': null,
          'Status': null,
          'Substatus': null,
          'Status Date': null,
          'Enrolment Received': null,
          'Enrolment Complete': null,
          'Enrolment Call 1': null,
          'Enrolment Call 2': null,
          'Enrolment Call 3': null,
          'Reimbursment Approved': null,
          'On Drug Date': null,
          'First Order Date': null,
          'First Dispense Date': null,
          'Dose': null,
          'Physician First Name': null,
          'Physician Last Name': null,
          'Physician Vector ID': null,
          'Institution': null,
          'Institution Vector ID': null,
          'Pharmacy': null,
          'Drug Type': null,
          'Reimbursement Type': null,
          'Reimbursement Status': null,
          'Current Therapies': null,
          'Previous Therapies': null,
          'Private Self': null,
          'Private Self Outcome': null,
          'Private Self % Coverage': null,
          'Private Self % Copayment': null,
          'Private Self Copayment Max Amount': null,
          'Private Self Deductible': null,
          'Private Self Maximum Amount': null,
          'Private Other': null,
          'Private Other Outcome': null,
          'Private Other % Coverage': null,
          'Private Other % Copayment': null,
          'Private Other Copayment Max Amount': null,
          'Private Other Deductible': null,
          'Private Other Maximum Amount': null,
          'Public': null,
          'Public Outcome': null,
          'Public % Coverage': null,
          'Public % Copayment': null,
          'Public Copayment Max Amount': null,
          'Public Deductible': null,
          'Public Maximum Amount': null,
        }
        Object.keys(p).forEach(key => {
          if (p[key]) {
            if (p[key].seconds)  {
              p[key] = this.utility.formatDate(p[key].toDate(),"DD-MMM-YY");
            }
            if (key === 'program_patient_id') {
              patientex['Patient ID'] = p[key];
            } else if (key === 'first_name') {
              patientex['First Name'] = p[key]
            } else if (key === 'last_name') {
              patientex['Last Name'] = p[key]
            } else if (key === 'province') {
              patientex['Province'] = p[key]
            } else if (key === 'therapy') {
              patientex['Therapy'] = p[key]
            } else if (key === 'indication') {
              patientex['Indication'] = p[key]
            } else if (key === 'diagnosis_date') {
              patientex['Diagnosis Date'] = p[key]  
            } else if (key === 'gender') {
              patientex['Gender'] = p[key] 
            } else if (key === 'weight') {
              patientex['Weight'] = p[key]  
            } else if (key === 'dob') {
              patientex['DOB'] = p[key] 
            } else if (key === 'status') {
              patientex['Status'] = p[key] 
            } else if (key === 'substatus') {
              patientex['Substatus'] = p[key]  
            } else if (key === 'status_date') {
              patientex['Status Date'] = p[key]  
            } else if (key === 'enrolment_received') {
              patientex['Enrolment Received'] = p[key]  
            } else if (key === 'enrolment_complete') {
              patientex['E Month'] = moment(p[key]).month();
              patientex['E Qtr'] = moment(p[key]).quarter();
              patientex['E Year'] = moment(p[key]).year();
              patientex['E Week'] = moment(p[key]).week();
              patientex['Enrolment Complete'] = p[key]  
            } else if (key === 'Enrolment_Call_1') {
              patientex['Enrolment Call 1'] = p[key]  
            } else if (key === 'Enrolment_Call_2') {
              patientex['Enrolment Call 2'] = p[key]  
            } else if (key === 'Enrolment_Call_3') {
              patientex['Enrolment Call 3'] = p[key] 
            } else if (key === 'reimbursement_approved') {
              patientex['Reimbursement Approved'] = p[key] 
            } else if (key === 'On_Drug') {
              patientex['On Drug Date'] = p[key] 
            } else if (key === 'order_first_date') {
              patientex['First Order Date'] = p[key]  
            } else if (key === 'dispensing_first_fill_date') {
              patientex['First Dispense Date'] = p[key]  
            } else if (key === 'dose') {
              patientex['Dose'] = p[key]  
            } else if (key === 'doctor')  {
              patientex['Physician First Name'] = p[key].first_name;
              patientex['Physician Last Name'] = p[key].last_name;
              patientex['Physician Vector ID'] = p[key].program_physician_id;
            } else if (key === 'clinic')  {
              patientex['Institution'] = p[key].name;
              patientex['Institution Vector ID'] = p[key].program_institution_id;
            } else if (key === 'clinical_current_medications') {
              patientex['Current Therapies'] = p[key].toString();
            } else if (key === 'clinical_previous_medications') {
              patientex['Previous Therapies'] = p[key].toString(); 
            } else if (key === 'drugtype') {
              patientex['Drug Type'] = p[key];
            } else if (key === 'reimbursementtype') {
              patientex['Reimbursement Type'] = p[key];
            } else if (key === 'reimbursementstatus') {
              patientex['Reimbursement Status'] = p[key];
            } else if (key === 'reimbursement_private') {
              patientex['Private Self'] = p[key].payer.name;
              patientex['Private Self Outcome'] = p[key].outcome_final;
              patientex['Private Self % Coverage'] = p[key].coverage;
              patientex['Private Self % Copayment'] = p[key].copayment;
              patientex['Private Self Copayment Max Amount'] = p[key].copayment_max;
              patientex['Private Self Deductible'] = p[key].deductible;
              patientex['Private Self Maximum Amount'] = p[key].max_amount;
            } else if (key === 'reimbursement_private_other') {
              patientex['Private Other'] = p[key].payer.name;
              patientex['Private Other Outcome'] = p[key].outcome_final;
              patientex['Private Other % Coverage'] = p[key].coverage;
              patientex['Private Other % Copayment'] = p[key].copayment;
              patientex['Private Other Copayment Max Amount'] = p[key].copayment_max;
              patientex['Private Other Deductible'] = p[key].deductible;
              patientex['Private Other Maximum Amount'] = p[key].max_amount;
            } else if (key === 'reimbursement_public') {
              patientex['Public'] = p[key].payer.name;
              patientex['Public Outcome'] = p[key].outcome_final;
              patientex['Public % Coverage'] = p[key].coverage;
              patientex['Public % Copayment'] = p[key].copayment;
              patientex['Public Copayment Max Amount'] = p[key].copayment_max;
              patientex['Public Deductible'] = p[key].deductible;
              patientex['Public Maximum Amount'] = p[key].max_amount;
            }
          }
        });
        this.apatients.push(patientex);
      });
      console.log('Patient for export: ', patients);
      this.dataSource = new MatTableDataSource(this.exportjson);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  exportPatients() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.apatients);
    workSheet['!autofilter'] = { ref: "A1:BG1" };
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Patients'); // add the worksheet to the book
    XLSX.writeFile(workBook, moment().format('YYYY-MMM-DD-HHssA') + '-patients.xlsx'); // initiate a file download in browser
  }
}



// WEBPACK FOOTER //
// ./src/pages/report-patient-details/report-patient-details.ts